import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformBusinessPage from '@src/pages/Platform/Business';

export const Route = createLazyFileRoute('/platform/business')({
  component: PlatformBusinessPageWithLayout,
});

function PlatformBusinessPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformBusinessPage />
    </DefaultLayout>
  );
}
